'use client';
import React, { useEffect, useState } from 'react';
import Icon from '@/components/ui/AppIcon';

interface StickyMobileBarProps {
  onBook: () => void;
}

export default function StickyMobileBar({ onBook }: StickyMobileBarProps) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handler = () => setVisible(window.scrollY > 400);
    window.addEventListener('scroll', handler, { passive: true });
    return () => window.removeEventListener('scroll', handler);
  }, []);

  return (
    <div
      className={`sticky-bar md:hidden ${visible ? 'visible' : ''}`}
      style={{
        background: 'rgba(17,17,19,0.95)',
        borderTop: '1px solid rgba(212,212,216,0.1)',
        backdropFilter: 'blur(12px)',
      }}
    >
      <div className="flex items-center gap-3 px-4 py-3 safe-area-inset-bottom">
        <button
          onClick={onBook}
          className="flex-1 btn-sapphire flex items-center justify-center gap-2 py-3.5 rounded-full mono text-[11px] font-semibold tracking-widest uppercase text-white"
        >
          <Icon name="CalendarDaysIcon" size={14} variant="outline" />
          Reserve Your Bay
        </button>
        <a
          href="tel:+15550001234"
          className="flex items-center justify-center w-12 h-12 rounded-full transition-colors"
          style={{ background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(212,212,216,0.12)' }}
          aria-label="Call us"
        >
          <Icon name="PhoneIcon" size={18} variant="outline" className="text-chrome" />
        </a>
      </div>
    </div>
  );
}